import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import FeastTeamMenuWarehouseCategoryEdit from './FeastTeamMenuWarehouseCategoryEdit';

export default function FeastTeamMenuWarehouseCategory(props: any) {

    //表头
    const columnsHead = [
        {
            title: '区域',
            dataIndex: 'areaName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.area.areaName}</div>
                )
            }
        },
        {
            title: '福食菜式分类',
            dataIndex: 'feastTeamMenuWarehouseCategoryName',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
            sorter: true,
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '福食菜式分类',
        apiId: 'feastTeamMenuWarehouseCategory',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: FeastTeamMenuWarehouseCategoryEdit,
        mountDataOptions: {
            userMount: {
                isBranchStore: true
            }
        }
    };

    return (
        <WebUniversalNewEx props={extendProps}></WebUniversalNewEx>
    )
}